import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { JSON } from 'domains/MediaPlatforms/Assets/Asset'
import { mediaPlatformAssetsRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets/Asset'

export const mediaPlatformAssetRoute = createRoute({
  getParentRoute: () => mediaPlatformAssetsRoute,
  path: DynamicRouteParameterWPrefix.ASSET_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const mediaPlatformAssetLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformAssetRoute,
  id: 'mediaPlatformAssetLayout',
  component: () => <Structure />,
})

export const mediaPlatformAssetRawRoute = createRoute({
  getParentRoute: () => mediaPlatformAssetLayoutRoute,
  path: '/',
  component: JSON,
})
